var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 377.325,
    height: 284.435,
    viewBox: "0 0 377.325 284.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9944",
    "data-name": "Group 9944",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9945",
    "data-name": "Group 9945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15491",
    "data-name": "Path 15491",
    d: "M261.24,48.587C276.9,43.476,291.957,38.344,307.159,33.7c7.593-2.322,15.352-3.659,23.507-2.045,10.048,1.989,17.254,7.3,21.993,16.211,7.044,13.237,9.966,27.558,11.3,41.769-9.275-4.124-18.337-9.092-28-12.177a107.834,107.834,0,0,0-27.736-5.15c-19.4-.849-33.7-10.688-46.979-23.717",
    fill: "#23416a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15492",
    "data-name": "Path 15492",
    d: "M269.8,249.217c-9.2,7.967-17.747,16.573-27.467,23.544-22.771,16.331-44.339,15.371-66.78-1.889-2.088-1.606-4.1-3.313-6.618-5.358,12.915-10.058,26.212-18.46,42.3-21.224,19.148-3.29,37.933.7,56.767,3.337.268.037.49.415,1.8,1.59",
    fill: "#23416a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15493",
    "data-name": "Path 15493",
    d: "M64.77,107.506c-7.513-20.693-4.54-37.722,13.285-51.58,16.432-12.774,36.188-14.158,57.2-15.146C124.466,57.3,117.164,74.809,102.709,87.407a38.681,38.681,0,0,1-7.831,5.256C85,97.679,75.009,102.48,64.77,107.506",
    fill: "#23416a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15494",
    "data-name": "Path 15494",
    d: "M44.822,255.563C33.39,256.07,20.3,247.789,20.28,230.94c-.015-14.738,10.976-24.321,24.876-24.521,13.2-.19,24.99,11.2,24.665,24.358-.4,16.433-12.758,25.39-25,24.786",
    fill: "#23416a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15495",
    "data-name": "Path 15495",
    d: "M360.52,0C369.5.07,377.4,8.039,377.325,16.947s-8.134,16.878-17.017,16.828c-8.792-.049-16.97-8.345-16.812-17.056A17.209,17.209,0,0,1,360.52,0",
    fill: "#23416a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15496",
    "data-name": "Path 15496",
    d: "M9.585,246.159a9.138,9.138,0,1,1-.4,18.266,9.138,9.138,0,1,1,.4-18.266",
    fill: "#23416a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.d87cc214d8837e573bd9310bf7511063.svg";
export { ForwardRef as ReactComponent };